import { useCallback, useEffect } from 'react';

import {
  sendEventOnClickHowWeSendApplicationModal,
  sendEventOnClickIncomeConfirmationPlaque,
  sendEventOnShowHowWeSendApplicationModal,
  sendEventOnShowIncomeConfirmationPlaque,
} from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

import { getAnalyticsOnIncomeConfirmationData } from 'entities/analytics';
import { useGetTimeOnCurrentStep } from 'entities/scenario';

import { useCommonMplAnalyticsParams } from './useCommonMplAnalyticsParams';

type TIncomeConfirmationOption = 'esia' | 'regular';

export const useIncomeConfirmationAnalytics = (offer: TOffer, isVisible: boolean) => {
  const commonMplAnalyticsParams = useCommonMplAnalyticsParams();
  const getTimeOnCurrentStepInSeconds = useGetTimeOnCurrentStep();

  const getEventData = useCallback(
    () => getAnalyticsOnIncomeConfirmationData(commonMplAnalyticsParams, offer, getTimeOnCurrentStepInSeconds()),
    [commonMplAnalyticsParams, getTimeOnCurrentStepInSeconds, offer],
  );

  const onShow = useCallback(() => {
    const data = getEventData();
    sendEventOnShowIncomeConfirmationPlaque(data);
    sendEventOnShowHowWeSendApplicationModal(data);
  }, [getEventData]);

  const onClickOption = useCallback(
    (option: TIncomeConfirmationOption) => {
      const data = getEventData();
      sendEventOnClickIncomeConfirmationPlaque(data, option);
      sendEventOnClickHowWeSendApplicationModal(data, option);
    },
    [getEventData],
  );

  useEffect(() => {
    if (isVisible) {
      onShow();
    }
    // Показ только при открытии: /next обновляет офер и searchOutput, onShow меняет ссылку.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return { onClickOption };
};
